export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const STATUS_COMANDA = {
  aberta: { label: 'Aberta', color: '#B45309', bg: '#FFFBEB' },
  enviada_ao_caixa: { label: 'No Caixa', color: '#0369A1', bg: '#F0F9FF' },
  paga: { label: 'Paga', color: '#1B4332', bg: '#F0FDF4' },
  cancelada: { label: 'Cancelada', color: '#71717A', bg: '#F4F4F5' },
};

export const formatCurrency = (v) =>
  new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v || 0);
